export default __webpack_public_path__ + "static/media/movi-img.172b970e.svg";